// extracted by mini-css-extract-plugin
export default {"popupWrapper":"PopUp_popupWrapper__TiImS","popup":"PopUp_popup__SZzbq"};